export default {
  common: {
    accept: 'cerca',
    confirmAccept: 'Si',
    confirmReject: 'No'
  },
  configMenu: {
    aircraftTag: {
      active: 'Activo',
      addAll: 'Agregar Todo',
      available: 'Disponible',
      resetAll: 'Restablecer todo',
    },
    configOption: {
      edit: 'Editar',
      delete: 'Eliminar',
      duplicate: 'Duplicar'
    },
    contentPlaceholder: {
      contentHere: 'El contenido irá aquí',
      creationPending: '--- CREACION PENDIENTE ---'
    },
    itemManager: {
      active: 'ACTIVOS',
      available: 'DISPONIBLES',
      createNew: 'Crear un nuevo ',
    },
    optionsFilters: {
      flightStatusInput: {
        label: 'Flight State',
        placeholder: 'Choose state'
      },
      airlinesInput: {
        label: 'Aerolíneas',
        placeholder: 'Elige aerolíneas'
      },
      buttonSave: 'Guardar',
      chooseTags: 'Elige etiquetas',
      destinationInput: {
        label: 'Destino',
        placeholder: 'Elige aeropuertos'
      },
      filterColor: 'Color de Filtro',
      filterTags: 'Etiquetas de Filtro',
      flightTags: 'Etiquetas de Vuelo',
      itemSelectorWaiting1: 'Esperando a que',
      itemSelectorWaiting2: 'se cargue...',
      matchAll: 'Coincidir con todos',
      matchAny: 'Coincidir con cualquiera',
      nameInput: {
        error: 'El filtro ya existe. Por favor usa otro nombre.',
        label: 'Nombre',
        placeholder: 'Ingresa el nombre de tu filtro'
      },
      noTags: 'Sin Etiquetas',
      originInput: {
        label: 'Origen',
        placeholder: 'Elige aeropuertos'
      },
    },
    optionsMap: {
      aircraftDetails: {
        selectionList: 'Lista de Selección'  
      }
    },
    optionsSettings: {
      airportCode: 'Código(s) del aeropuerto',
      iconSize: 'Tamaño de ícono',
      radius: 'Radio en nm',  
      maxTimeAllowed: 'Límite de tiempo máximo permitido en minutos',
      holdOnly: 'Solo Vuelos en Patron de Espera',
      noOfCircles: 'Número de círculos',
    },
    optionsWeather: {
      resetAll: 'Restablecer todo'
    },
  },
  fontCustomizer: {
    resizeTitle: 'Tamaño de Fuente',
  },
  home: {
    buttonLogout: 'Cerrar Sesión',
    buttonRetry: 'Reintentar',
    internetFailed: '¡Falló la conexión a Internet!',  
  },
  header: {
    buttonDelete: 'Eliminar',
    buttonLoad: 'Cargar',
    buttonSave: 'Guardar',
    errorMessages: {
      deleteComponent: 'No puede eliminar el componente activo',
      deleteLayout: 'No puede eliminar el diseño activo',
      duplicateLayoutName: `Ya existe un diseño llamado {{layoutName}}`,
    },
    layoutName: {
      label: 'Nombre de Diseño',
      placeholder: 'Ingrese el nombre',
    },
    layoutLoading: `Cargando Diseño {{layoutName}}...`,
    layoutManagement: {
      active: 'Activo',
      addComponents: 'Agregar componentes',
      buildLayout: 'Construye un nuevo diseño',
      buttonContinue: 'Continuar',
      defaultComponents: 'Componentes por defecto',
      dragComponents: 'Arrastre el componente a la sección deseada.',
      inputName: {
        label: 'Nombre',  
      },
      layoutDelete: '¿Eliminar este diseño?',  
      nameLayout: 'Nombra tu diseño',
      savedComponents: 'Componentes guardados',
      save: 'Guardar',
      saveAsNew: 'Guardar como nuevo',
      saveAsNewLayout: 'Guardar como nuevo diseño',
      tabAll: 'Todos',
      tabRecent: 'Recientes',
      tabStarred: 'Favoritos',
    },
    myLayouts: 'Mis Diseños',
    replay: {
      ongoing: 'Fecha y hora de reproducción en curso:',  
      pause: 'Pausa',
      resume: 'Reanudar',
      selectDateTime: 'Seleccione una fecha y hora de los últimos 30 días:',
      selectSpeed: 'Seleccione una velocidad de reproducción:',
      start: 'Comenzar',
      stop: 'Detener',
    },
  },
  loading: 'Cargando...',
  login: {
    authentication: 'Comprobando autenticación...',
    errorMsgAuth: 'Nombre de usuario y/o contraseña incorrectos',
    errorMsgNetw: 'Se ha producido un error de red',
    buttonLogin: 'Iniciar Sesión',
    inputUserName: 'Nombre de usuario',
    inputPassword: 'Contraseña',
    
  },
  mainMenu: {
    aviationWeather: 'Centro Meteorológico de Aviación',
    components: 'Componentes',
    dark: 'Oscuro',
    darkGrey: 'Gris Oscuro',
    faaOis: 'FAA OIS',
    layout: 'Diseño',
    light: 'Claro',
    lightGrey: 'Gris Claro',
    replay: 'Repetición',
    themes: 'Temas',
  },
  map: {
    flightUInfo: 'Informacion de vuelo',  
  },
  tile: {
    saveComponent: {
      buttonSave: 'Guardar',
      saveOptions: 'Opciones de Guardar'
    },
    tileSplitter: {
      componentName: {
        label: 'Nombre del Componente',
        placeholder: 'Ingresa el nombre'
      },
      defaultComponents: 'Componentes Predeterminados',
      position: 'Posición',
      splitOptions: 'Opciones de División',
      splitToBottom: ' Dividir hacia Abajo',
      splitToLeft: ' Dividir a la Izquierda',
      splitToRight: ' Dividir a la Derecha',
      splitToTop: ' Dividir hacia Arriba'
    },
    toolbar: {
      deleteTile: ' Eliminar Mosaico',
      options: ' Opciones',
      save: ' Guardar',
      split: ' Dividir ',
      swap: ' Intercambiar'
    }  
  }
}
